import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import QRCode from 'react-qr-code';
import ReactToPrint from 'react-to-print';
import { getCurrentUser } from '../store/actions/auth';
import PasswordChangeModal from '../components/PasswordChangeModal.jsx';
import EditProfileModal from '../components/EditProfileModal.jsx';
import PinChangeModal from '../components/PinChangeModal';
import { MENU_WIDTH, ROOT } from '../constants';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    paddingLeft: MENU_WIDTH,
    paddingTop: '6rem',
  },
  header: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignContent: 'center',
    marginBottom: '1rem',
  },
  title: {
    margin: 0,
  },
  form: {
    width: '60%',
    padding: '2rem',
    display: 'flex',
    flexDirection: 'column',
  },
  field: {
    width: '100%',
    marginBottom: '1rem',
    '& input.Mui-disabled': {
      color: 'black',
    },
  },
  button: {
    color: 'white',
    backgroundColor: '#00d1b2',
    maxWidth: 250,
    maxHeight: 40,
    marginRight: 20,
    '&:hover': {
      backgroundColor: '#00bca0',
    },
  },
  row: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
  },
  qrContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginLeft: 20,
  },
  qr: {
    marginTop: 10,
  },
}));

const Profile = () => {
  const dispatch = useDispatch();
  const [passwordModalOpen, setPasswordModalOpen] = useState(false);
  const classes = useStyles();
  const user = useSelector((state) => state.admin.currentUserInfo);
  const printRef = useRef();
  const [editProfileModalOpen, setEditProfileModalOpen] = useState(false);
  const [pinModalOpen, setPinModalOpen] = useState(false);
  const [patientsText, setPatientsText] = useState('');
  const [groupsText, setGroupsText] = useState('');

  useEffect(() => {
    dispatch(getCurrentUser());
  }, [dispatch]);

  useEffect(() => {
    if (user && user.patients) {
      let text = '';
      user.patients.forEach((patient, index) => {
        if (index) text = `${text}, `;
        text = `${text}${patient.first_name} ${patient.last_name}`;
      });
      setPatientsText(text);
    }
    if (user && user.groups) {
      let text = '';
      user.groups.forEach((group, index) => {
        if (index) text = `${text}, `;
        text = `${text}${group.name}`;
      });
      setGroupsText(text);
    }
  }, [user]);

  return (
    <div className={classes.root}>
      <EditProfileModal open={editProfileModalOpen} setOpen={setEditProfileModalOpen} />
      <PasswordChangeModal open={passwordModalOpen} setOpen={setPasswordModalOpen} />
      <PinChangeModal open={pinModalOpen} setOpen={setPinModalOpen} />
      <div className={classes.row}>
        <form className={classes.form}>
          <div className={classes.header}>
            <h2 className={classes.title}>Personal Information</h2>
            <Button variant="contained" className={classes.button} onClick={() => setEditProfileModalOpen(true)}>
              Edit
            </Button>
          </div>
          <TextField
            className={classes.field}
            helperText="First Name"
            value={user.first_name || ''}
            InputProps={{
              readOnly: true,
            }}
          />
          <TextField
            className={classes.field}
            helperText="Last Name"
            value={user.last_name || ''}
            InputProps={{
              readOnly: true,
            }}
          />
          <TextField
            className={classes.field}
            helperText="Email"
            value={user.email || ''}
            InputProps={{
              readOnly: true,
            }}
          />
          <TextField
            className={classes.field}
            helperText="Phone Number"
            value={user.phone_number || ''}
            InputProps={{
              readOnly: true,
            }}
          />
          {user && user.role && user.role.name === 'HCP' && (
            <TextField
              className={classes.field}
              helperText="Supervisor"
              value={user.supervisor ? `${user.supervisor.first_name} ${user.supervisor.last_name}` : ''}
              InputProps={{
                readOnly: true,
              }}
            />
          )}
          <TextField
            className={classes.field}
            helperText="Patients"
            value={patientsText}
            InputProps={{
              readOnly: true,
            }}
          />
          <TextField
            className={classes.field}
            helperText="Groups"
            value={groupsText}
            InputProps={{
              readOnly: true,
            }}
          />
          <div className={classes.row}>
            <Button variant="contained" className={classes.button} onClick={() => setPasswordModalOpen(true)}>
              Reset Password
            </Button>
            {user.pin && (
              <Button variant="contained" className={classes.button} onClick={() => setPinModalOpen(true)}>
                Generate New PIN
              </Button>
            )}
          </div>
        </form>
        {user.pin && (
          <div className={classes.qrContainer}>
            <ReactToPrint
              trigger={() => <Button variant="contained">Print QR Code</Button>}
              content={() => printRef.current}
            />
            <QRCode
              className={classes.qr}
              ref={printRef}
              value={`neuralert://qrcodelaunch?baseUrl=${ROOT}&username=${user.email}`}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Profile;
